<template>
  <div class="page-hsylc-scene-form">
    <router-view />
  </div>
</template>
<script>
import './index.less';
export default {
  name: 'SceneForms'
};
</script>
